import { Injectable } from '@angular/core';
import {
    HttpClient,
    HttpBackend,
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';
import { environment } from "src/environments/environment";
import { Observable, throwError } from 'rxjs';
import { tap, map, catchError, switchMap } from 'rxjs/operators';
import { SharedService } from 'src/app/shared/shared.service';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    public jwtHelper: JwtHelperService = new JwtHelperService();
    private httpBackend: HttpClient;

    constructor(private http: HttpClient,
        private _httpBackend: HttpBackend,
        private sharedService: SharedService) {
        this.httpBackend = new HttpClient(this._httpBackend);
    }

    public isValidAccessToken() {
        const AccessToken = this.sharedService.AccessToken;
        if (AccessToken && !this.jwtHelper.isTokenExpired(AccessToken)) {
            return true;
        }
        return false;
    }

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        request.serializeBody();

        var skipLoader: boolean = false;
        var skipRefreshToken: boolean = false;
        if (request.url.includes("push-notification")) {
            skipLoader = true;
            skipRefreshToken = true;
        }
        if (request.url.includes("api/quest/save")) {
            skipLoader = true;
        }
        if (!skipLoader) {
            this.onRequestStart(request);
        }
        if (this.sharedService.AccessToken && !skipRefreshToken) {
            if (this.isValidAccessToken()) {
                return this.handleRequest(next, request);
            } else {
                return this.refreshingToken(next, request);
            }
        } else {
            return this.handleRequest(next, request);
        }
    }

    private refreshingToken(next: HttpHandler, request: HttpRequest<any>) {
        let payload = {
            AccessToken: this.sharedService.AccessToken,
            RefreshToken: this.sharedService.RefreshToken
        }
        return this.httpBackend.post(`${environment.APIUrl}/api/auth/refresh-token`, payload).pipe(
            tap(response => {
                this.sharedService.setAuthDetail(response);
            }),
            switchMap((response) => {
                return this.handleRequest(next, request);
            }),
            catchError((error) => {
                this.onRequestComplete(request, error);
                this.sharedService.navigateToLogin(`/login`);
                return throwError(() => (error.error || "Richiesta non autorizzata"));
            })
        );
    }

    private handleRequest(next: HttpHandler, request: HttpRequest<any>) {
        return next.handle(this.addToken(request)).pipe(
            map((respoonse: HttpEvent<any>) => {
                this.onRequestComplete(request, respoonse);
                return respoonse;
            }),
            catchError((error: HttpErrorResponse) => {
                return this.catchErrorResponse(request, error);
            }));
    }

    private catchErrorResponse(request: HttpRequest<any>, error: HttpErrorResponse) {
        this.onRequestComplete(request, error);
        let errorMsg = error.error || error.message || '';
        if (error.status === 0) {
            errorMsg = "Si è verificato un errore tecnico. Contatta l'assistenza per ricevere assistenza.";
        } else if (error.status === 401) {
            errorMsg = "Richiesta non autorizzata";
            this.sharedService.navigateToLogin(`/login`);
        } else if (error.status === 504) {
            errorMsg = "Nessuna connessione Internet. Per favore riprova.";
        }
        return throwError(() => (errorMsg || "A causa di un errore tecnico non possiamo elaborare la tua richiesta."));
    }

    private addToken(request: HttpRequest<any>) {
        const requestHeaders = {};
        if (this.sharedService.AccessToken) {
            requestHeaders['Authorization'] = `Bearer ${this.sharedService.AccessToken}`;
        }
        return request = request.clone({
            setHeaders: requestHeaders
        });
    }

    private showHideSplashScreen(method, show) {
        if (["POST", "PUT", "DELETE"].indexOf(method) > -1) {
            this.sharedService.busySpinner.next(show);
        }
    }

    private onRequestStart(request: HttpRequest<any>) {
        this.showHideSplashScreen(request.method, true);
    }

    private onRequestComplete(request: HttpRequest<any>, response) {
        if (response && (response.type > 0 || response.status >= 0)) {
            this.showHideSplashScreen(request.method, false);
        }
    }
}
